import { TagChip } from '@/components/tags/TagChip';
import { EpisodeStatus } from '@/types/graphql';
import { SxStyle } from '@/utils/reactTypes';

import { renderEpisodeStatus } from './renderers';

interface EpisodeStatusTagProps {
    status: EpisodeStatus;
    sx?: SxStyle;
    displayActive?: boolean;
    displayRecertified?: boolean;
}

export const EpisodeStatusTag = ({
    status,
    sx,
    displayRecertified = false,
    displayActive = false,
}: EpisodeStatusTagProps) => {
    if (!displayActive && status === EpisodeStatus.ACTIVE) {
        return null;
    }
    if (!displayRecertified && status === EpisodeStatus.RECERTIFIED) {
        return null;
    }
    return <TagChip label={renderEpisodeStatus(status)} size='small' sx={sx} />;
};
